/* istanbul ignore file */
import React from 'react';
import { Breadcrumbs, ListBreadcrumbItem } from 'framework/ui/BreadCrumbs';
import { useEmployeeUrl } from 'domain/shared/employee';

const EmployeesBreadcrumbs = ({ children = null }: { children?: React.ReactNode }) => {
  const { getListUrl } = useEmployeeUrl();

  return (
    <Breadcrumbs>
      <ListBreadcrumbItem entity="Workers" link={getListUrl()} />
      {children}
    </Breadcrumbs>
  );
};

export default EmployeesBreadcrumbs;
